import { render } from "./FilterUniversal.vue?vue&type=template&id=4d5053a4&ts=true"
import script from "./FilterUniversal.vue?vue&type=script&lang=ts"
export * from "./FilterUniversal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__